<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title>
                        گزارش نرخ خرید و تحویل بار
                    </v-card-title>
                    <v-card-text>
                        <div class="container">
                            <v-row>
                                <v-col cols="4">
                                    <v-row form class="form-group">
                                        <label>
                                            از مبدا بارگیری
                                        </label>
                                        <div dir="rtl">
                                            <treeselect
                                                    :matchKeys="['code']"
                                                    v-model="start_selected_origin_load"
                                                    :cacheOptions="false"
                                                    :options="origin_loads"
                                                    placeholder="جستجو مبدا بارگیری"
                                                    :normalizer="normalizer_origin"
                                            />
                                        </div>
                                    </v-row>
                                    <v-row form class="form-group">
                                        <label>
                                            تا مبدا بارگیری
                                        </label>
                                        <div dir="rtl">
                                            <treeselect
                                                    :matchKeys="['code']"
                                                    v-model="end_selected_origin_load"
                                                    :cacheOptions="false"
                                                    :options="origin_loads"
                                                    placeholder="جستجو مبدا بارگیری"
                                                    :normalizer="normalizer_origin"
                                            />
                                        </div>
                                    </v-row>


                                </v-col>
                                <v-col cols="4">
                                    <v-row form class="form-group">
                                        <label>
                                            از محل تخلیه
                                        </label>
                                        <div dir="rtl">
                                            <treeselect
                                                    :matchKeys="['code']"
                                                    v-model="start_selected_discharge_place"
                                                    :cacheOptions="false"
                                                    :options="discharge_places"
                                                    placeholder="جستجو محل تخلیه"
                                                    :normalizer="normalizer_discharge_place"
                                            />
                                        </div>
                                    </v-row>
                                    <v-row form class="form-group">
                                        <label>
                                            تا محل تخلیه
                                        </label>
                                        <div dir="rtl">
                                            <treeselect
                                                    :matchKeys="['code']"
                                                    v-model="end_selected_discharge_place"
                                                    :cacheOptions="false"
                                                    :options="discharge_places"
                                                    placeholder="جستجو محل تخلیه"
                                                    :normalizer="normalizer_discharge_place"
                                            />
                                        </div>
                                    </v-row>
                                </v-col>
                                <v-col cols="4">
                                    <v-row form class="form-group">
                                        <label>
                                            از نوع جنس
                                        </label>
                                        <div dir="rtl">
                                            <treeselect
                                                    :matchKeys="['code']"
                                                    v-model="start_selected_load_type"
                                                    :cacheOptions="false"
                                                    :options="load_types"
                                                    placeholder="جستجو نوع جنس"
                                                    :normalizer="normalizer_load_type"
                                            />
                                        </div>
                                    </v-row>
                                    <v-row form class="form-group">
                                        <label>
                                            تا نوع جنس
                                        </label>
                                        <div dir="rtl">
                                            <treeselect
                                                    :matchKeys="['code']"
                                                    v-model="end_selected_load_type"
                                                    :cacheOptions="false"
                                                    :options="load_types"
                                                    placeholder="جستجو نوع جنس"
                                                    :normalizer="normalizer_load_type"
                                            />
                                        </div>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <div class="row ">
                                <v-data-table
                                    dense
                                    height="400"
                                    fixed-header
                                    hide-default-footer
                                    disable-pagination
                                    multi-sort
                                        class="margin-auto table-bordered"
                                        :headers="headers"
                                        :items-per-page="3000"
                                        :items="filtered_items"
                                >
                                    <template v-slot:item.buy_price="{ item }">
                                        <p>{{get_currency(item.buy_price)}}</p>
                                    </template>
                                    <template v-slot:item.delivery_price="{ item }">
                                        <p>{{get_currency(item.delivery_price)}}</p>
                                    </template>

                                </v-data-table>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
    import Vue from 'vue'
    import { bus } from '../../main'
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'

    export default {
        name: 'OriginDownload',
        components: { Treeselect },
        data () {
            return {
                confirm_delete_name: 'confirm_delete' + new Date().getTime() + '_' + this.$vnode.tag,
                items: [],
                filtered_items: [],
                status_form: 0,
                origin_loads: [],
                discharge_places: [],
                load_types: [],
                start_selected_origin_load: null,
                end_selected_origin_load: null,
                start_selected_discharge_place: null,
                end_selected_discharge_place: null,
                start_selected_load_type: null,
                end_selected_load_type: null,
                headers: [
                    {
                        text: 'مبدا بارگیری',
                        value: 'origin_load'
                    },
                    {
                        text: 'محل تخلیه',
                        value: 'discharge_place'
                    },
                    {
                        text: 'نوع جنس بار',
                        value: 'load_type'
                    },
                    {
                        text: 'مبلغ خرید',
                        value: 'buy_price'
                    },
                    {
                        text: 'مبلغ تحویل',
                        value: 'delivery_price'
                    },
                    {
                        text: '% مالیات خرید',
                        value: 'buy_tax'
                    },
                    {
                        text: '% مالیات تحویل',
                        value: 'delivery_tax'
                    },
                ],

                normalizer_origin (node) {
                    return {
                        id: node.id,
                        label: node.code + ' - ' + node.name,
                        code:node.code,

                    }
                },
                normalizer_load_type (node) {
                    return {
                        id: node.id,
                        label: node.code + ' - ' + node.name,
                        code:node.code,

                    }
                },
                normalizer_discharge_place (node) {
                    return {
                        id: node.id,
                        label: node.code + ' - ' + node.name,
                        code:node.code,

                    }
                },
            }
        },
        mounted () {
            this.get_data()
            this.get_origin_downloads()
            this.get_load_types()
            this.get_discharge_places()
            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == 'true') {
                    this.delete_item()

                } else {
                    this.status_form = 0
                }
            })
        },
        watch: {
            start_selected_origin_load: function () {
                this.filter_data()
            },
            end_selected_origin_load: function () {
                this.filter_data()

            },
            start_selected_discharge_place: function () {
                this.filter_data()

            },
            end_selected_discharge_place: function () {
                this.filter_data()

            },
            start_selected_load_type: function () {
                this.filter_data()

            },
            end_selected_load_type: function () {
                this.filter_data()

            },
        },
        methods: {
            filter_data () {
                console.log("filter_called")
                this.filtered_items = this.items
                if (this.start_selected_discharge_place != null) {
                    this.filtered_items = this.filtered_items.filter(x => x.discharge_place_code >= this.start_selected_discharge_place)
                }
                if (this.end_selected_discharge_place != null) {
                    this.filtered_items = this.filtered_items.filter(x => x.discharge_place_code <= this.end_selected_discharge_place)
                }

                if (this.start_selected_load_type != null) {
                    this.filtered_items = this.filtered_items.filter(x => x.load_type_code >= this.start_selected_load_type)
                }
                if (this.end_selected_load_type != null) {
                    this.filtered_items = this.filtered_items.filter(x => x.load_type_code <= this.end_selected_load_type)
                }

                if (this.start_selected_origin_load != null) {
                    this.filtered_items = this.filtered_items.filter(x => x.origin_load_code >= this.start_selected_origin_load)
                }
                if (this.end_selected_origin_load != null) {
                    this.filtered_items = this.filtered_items.filter(x => x.origin_load_code <= this.end_selected_origin_load)
                }
            },
            get_data () {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/price_buy_delivery/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.items = response.data.data
                        self.filtered_items = response.data.data

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            get_origin_downloads () {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/origin/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.origin_loads = response.data.data

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            get_load_types () {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/load_type/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.load_types = response.data.data

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    console.log(error)
                })

            },
            get_discharge_places () {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/discharge_places/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.discharge_places = response.data.data

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },

        }
    }
</script>
